import { useEffect } from "@wordpress/element";
import { useRulesContext } from "../../../../hook/useRulesContext";
import ModalHeader from "./ModalElements/ModalHeader";
import ModalForm from "./ModalElements/ModalForm";
import ModalFooter from "./ModalElements/ModalFooter";
import ModalNavigation from "./ModalElements/ModalNavigation";

export default function RuleModal() {
    const { showAddModal } = useRulesContext();

    useEffect(() => {
        if (showAddModal) {
            // Disable scroll
            document.body.style.overflow = "hidden";
        } else {
            // Re-enable scroll
            document.body.style.overflow = "";
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = "";
        };
    }, [showAddModal]);

    if (!showAddModal) return null;

    return (
        <div className="fixed inset-0 z-[99999] overflow-y-auto bg-black/40">
            <div className="flex min-h-screen items-center justify-center p-4">
                {/* Backdrop */}
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity" />

                {/* Modal */}
                <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-[1180px] max-h-[90vh] overflow-hidden">
                    <ModalHeader />
                    <ModalNavigation />
                    <ModalForm />
                    <ModalFooter />
                </div>
            </div>
        </div>
    );
}
